/**
 * Subscribe to a media query.
 *
 * Used for the breakpoints that change *structure* rather than style — the nav
 * collapsing, the waitlist CTA moving inside its panel — which CSS cannot
 * express because they change which elements exist rather than how they look.
 * Anything expressible in a media query stays in CSS.
 */

import { useEffect, useState } from 'react';

export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;
    const mq = window.matchMedia(query);
    const sync = (): void => {
      setMatches(mq.matches);
    };
    sync();
    mq.addEventListener('change', sync);
    return () => {
      mq.removeEventListener('change', sync);
    };
  }, [query]);

  return matches;
}
